import { render, staticRenderFns } from "./EstablishmentSettings.vue?vue&type=template&id=75728e62&"
import script from "./EstablishmentSettings.vue?vue&type=script&lang=js&"
export * from "./EstablishmentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EstablishmentSettings.vue"
export default component.exports